function ReportScheduleEmail() {
    "use strict";

    this.__type = 'ReportScheduleEmail:www.veritracks.com';
    this.Id = -1;
    this.ReportScheduleId = -1;
    this.UserEmail = '';
    this.IsActive = true;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
}
if (typeof exports !== 'undefined') {
    module.exports = ReportScheduleEmail;
}